module.exports = __webpack_public_path__ + "img/shop_btn.ae9fc800.png";